module.exports = __webpack_public_path__ + "img/Banner-Sijakon-Material.63131360.png";